import { gql } from '@apollo/client';
import { APPROVAL_FIELDS_FRAGMENT } from './fragments';

/**
 * List all approvals for tenant (paginated)
 */
export const LIST_APPROVALS = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListApprovals($tenantId: String!, $limit: Int, $cursor: String) {
    listApprovals(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...ApprovalFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

/**
 * Get single approval by ID
 */
export const GET_APPROVAL = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query GetApproval($tenantId: String!, $approvalId: String!) {
    getApproval(tenantId: $tenantId, approvalId: $approvalId) {
      ...ApprovalFields
    }
  }
`;

/**
 * List approvals by status
 */
export const LIST_APPROVALS_BY_STATUS = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListApprovalsByStatus($tenantId: String!, $status: ApprovalStatus!, $limit: Int) {
    listApprovalsByStatus(tenantId: $tenantId, status: $status, limit: $limit) {
      items {
        ...ApprovalFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

/**
 * List approvals by approver actor ID
 */
export const LIST_APPROVALS_BY_APPROVER = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListApprovalsByApprover($tenantId: String!, $approverId: String!, $limit: Int) {
    listApprovalsByApprover(tenantId: $tenantId, approverId: $approverId, limit: $limit) {
      items {
        ...ApprovalFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

/**
 * List approvals in approval chain
 */
export const LIST_APPROVALS_BY_CHAIN = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListApprovalsByChain($tenantId: String!, $approvalChainId: String!) {
    listApprovalsByChain(tenantId: $tenantId, approvalChainId: $approvalChainId) {
      items {
        ...ApprovalFields
      }
      total
    }
  }
`;

/**
 * List pending approvals for approver
 */
export const LIST_PENDING_APPROVALS = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListPendingApprovals($tenantId: String!, $approverId: String!, $limit: Int) {
    listPendingApprovals(tenantId: $tenantId, approverId: $approverId, limit: $limit) {
      items {
        ...ApprovalFields
      }
      total
      nextCursor
      hasMore
    }
  }
`;

/**
 * List approvals expiring before date
 */
export const LIST_EXPIRING_APPROVALS = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query ListExpiringApprovals($tenantId: String!, $beforeDate: String!, $limit: Int) {
    listExpiringApprovals(tenantId: $tenantId, beforeDate: $beforeDate, limit: $limit) {
      items {
        ...ApprovalFields
      }
      total
    }
  }
`;

/**
 * Get approval statistics for tenant
 */
export const GET_APPROVAL_STATS = gql`
  query GetApprovalStats($tenantId: String!) {
    getApprovalStats(tenantId: $tenantId) {
      totalApprovals
      pendingApprovals
      approvedCount
      rejectedCount
      escalatedCount
      expiredCount
      avgDecisionTimeHours
      approvalRate
    }
  }
`;

/**
 * Get approval history for entity
 */
export const GET_APPROVAL_HISTORY = gql`
  ${APPROVAL_FIELDS_FRAGMENT}
  query GetApprovalHistory($tenantId: String!, $entityId: String!) {
    getApprovalHistory(tenantId: $tenantId, entityId: $entityId) {
      items {
        ...ApprovalFields
      }
      total
    }
  }
`;
